import * as firebase from "firebase";
import "firebase/auth";

import firebaseConfig from "./firebaseConfig";

// Initialize Firebase App

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();

export const loginWithEmail = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

export const registerWithEmail = (name, email, password) =>
  auth.createUserWithEmailAndPassword(email, password).then((result) => {
    result.user.updateProfile({
      displayName: name,
      photoURL: require("../../Leaderboard/unknownPerson.png"),
    });
    console.log(result.user);
    firebase
      .database()
      .ref("profile/" + result.user.uid)
      .update({
        displayName: name,
        profilePic: require("../../Leaderboard/unknownPerson.png"),
      });
  });

export const logout = () => auth.signOut();

export const passwordReset = (email) => auth.sendPasswordResetEmail(email);
